import { Navigate } from "react-router";
import { useGetContractorQuery } from "../../../apis/Contractor.api";
import { PrimaryContractor, Contractor } from "../../../types/models/Contractor";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ContractorScoped = () => {
    const {
        data,
    } = useGetContractorQuery(PrimaryContractor.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/contractors/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ContractorScoped;
